import { SparkleIcon } from '@phosphor-icons/react';

import { Alert } from 'components/alert/Alert';
import { useTranslation } from 'contexts/translation-context';

/**
 * Says that FleetMaster is the first of several tracking providers.
 *
 * The connections list is provider-agnostic, so nothing else on the page hints that more are coming —
 * and without it a single-vendor screen reads as the whole offer. Every connector we register shows up
 * in the list above on its own, so this needs no list of its own.
 */
export const UpcomingConnectionsBanner = () => {
  const { i18n } = useTranslation();

  return (
    <Alert type="info" icon={<SparkleIcon />} title={i18n('liveTracking.moreConnectionsTitle')}>
      {i18n('liveTracking.moreConnectionsBody')}
    </Alert>
  );
};
